<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    width="700px"
    submit-btn-name="Generate"
    @submit="submitForm"
    @close="resetFormData"
  >
    <v-form :ref="formRef">
      <v-select
        v-model="selectedRoles"
        :items="roles"
        label="Roles"
        clearable
        multiple
        chips
      />
      <v-text-field
        v-model.trim.number="days"
        :rules="validator.getRulesByField('days')"
        label="Lifetime (days)"
        @keypress.enter="submitForm"
      />
    </v-form>
    <v-tooltip
      v-if="generatedToken"
      top
    >
      <template #activator="{ on }">
        <span
          :id="longTimeTokenGeneratorId"
          v-on="on"
        >
          <v-textarea
            :value="generatedToken"
            readonly
            @click="copyToken"
          />
        </span>
      </template>
      Click to copy token
    </v-tooltip>
  </vbt-dialog>
</template>

<script>
import { useDialog, useFormWithRef } from '@mixins/factories';

import {
  Validator,
  copyToClipboard,
  generateShortID,
  wrapToLoadingFn,
} from '@helpers';

import ApplicationsApiService from '../_services/applications.api.service';

const validator = Validator.createValidator({
  days: ['required', { rule: 'min', value: 1 }, { rule: 'max', value: 600 }],
});

export default {
  name: 'UmsApplicationLongTimeTokenGenerator',
  props: {
    app: {
      type: String,
      default: '',
    },
    roles: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [
    useDialog(),
    useFormWithRef(),
    Validator.useValidator(validator),
  ],
  data: () => ({
    days: 1,
    selectedRoles: [],
    generatedToken: '',
    longTimeTokenGeneratorId: generateShortID(),
  }),
  computed: {
    title() {
      return `Generate longtime token for application ${this.app}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.generatedToken = '';

      this.wrapToLoadingFn({
        req: ApplicationsApiService.generateLongtimeToken.bind({}, {
          app: this.app,
          lifeTimeDays: this.days,
          roles: this.selectedRoles?.length ? this.selectedRoles : null,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: (token) => {
          this.days = 1;
          this.selectedRoles = [];
          this.generatedToken = token;
        },
      });
    },
    async copyToken() {
      await copyToClipboard(this.generatedToken, this.longTimeTokenGeneratorId);
      this.$VBlackerTheme.notification.success('Token successfully copied');
    },
    resetFormData() {
      this.days = 1;
      this.selectedRoles = [];
      this.generatedToken = '';
      this.$_resetFormValidation();
    },
  },
};
</script>
